<template>
  <div class="publicity-top">
    <publicity-header project="publicity-green-report-header"></publicity-header>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  methods: {
    goToGreenSupplyChain() {
      this.$router.push('/')
    }
  }
}
</script>

<style src="@/styles/publicity-navbar.css"></style>
